import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from '@iw-shared/core/classes/auth-guard';
import {PageAuthenticationLoginComponent} from "@account/_pages/authentication/login/page-authentication-login.component";
import {
  PageAuthenticationPasswordLostComponent
} from "@account/_pages/authentication/password-lost/page-authentication-password-lost.component";
import {
  PageAuthenticationPasswordResetComponent
} from "@account/_pages/authentication/password-reset/page-authentication-password-reset.component";

const routes: Routes = [
  {path: 'login', component: PageAuthenticationLoginComponent},
  {path: 'password-lost', component: PageAuthenticationPasswordLostComponent},
  {path: 'password-reset', component: PageAuthenticationPasswordResetComponent},
  {

    path: '', canActivate: [AuthGuard], children: [
      {
        path: 'shop',
        loadChildren: () => import('@account/_pages/shop/shop.module').then(m => m.ShopModule)
      },
      {
        path: 'data',
        loadChildren: () => import('@account/_pages/data/data.module').then(m => m.DataModule)
      },
      {
        path: 'content',
        loadChildren: () => import('@account/_pages/content/content.module').then(m => m.ContentModule)
      },
      {
        path: 'account',
        loadChildren: () => import('@account/_pages/tours-and-areas/tours-and-areas.module').then(m => m.ToursAndAreasModule)
      },
      {
        path: 'admin',
        loadChildren: () => import('@account/_pages/admin/admin.module').then(m => m.AdminModule)
      },
      {
        path: '**', redirectTo: 'data/articles/list'
      }
    ]
  },
  // otherwise redirect to home
  {path: '**', redirectTo: '/login'}
];


@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled'
    })

  ],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
